import React from 'react';
import { useHistory } from 'react-router-dom';
import { ArrowLeftIcon } from '~web/view/components/ui/icon/arrow-left.icon';

interface Props {
  onBack?: () => void; // use this prop to override the going back behavior
}

export const BackButton: React.FunctionComponent<Props> = ({ onBack, ...rest }) => {
  const history = useHistory();
  return (
    <ArrowLeftIcon
      width={12}
      height={18}
      onClick={
        onBack
          ? onBack
          : (): void => {
              history.goBack();
            }
      }
      {...rest}
    />
  );
};



// WEBPACK FOOTER //
// /codebuild/output/src332225586/src/modules/web/src/js/view/components/ui/button/back-button.component.tsx